import { Decimal, Money } from "@station/core";
/**
 * Kullanıcının yazdığı tutarı kuruşa çevirir — float KULLANMADAN.
 * Türkiye yazımı esas alınır: "." binlik, "," ondalık. "1.234,56", "1234,5", "1234" kabul edilir.
 * "12.50" gibi belirsiz yazımlar SESSİZCE yorumlanmaz; hata döner (12,50 mi, 1.250 mi?).
 */
export function parseMoneyInput(text, options = {}) {
    const trimmed = text.replace(/₺|TL/gi, "").replace(/\s/g, "");
    if (trimmed === "")
        return { ok: true, value: null };
    try {
        const decimal = Decimal.parseTr(trimmed);
        if (decimal.isNegative() && !options.allowNegative)
            return { ok: false, message: "Tutar negatif olamaz" };
        if (!decimal.mul(100).isInteger())
            return { ok: false, message: "En fazla 2 ondalık basamak girilebilir" };
        return { ok: true, value: Money.fromMajor(decimal).toString() };
    }
    catch {
        return { ok: false, message: "Geçerli bir tutar girin (ör. 1.234,56)" };
    }
}
/** Kuruş dizgesini düzenleme biçimine çevirir: "123456" → "1.234,56" */
export function formatMoneyInput(minor) {
    if (minor === null || minor === undefined || minor === "")
        return "";
    return Money.fromMinor(minor).formatTr({ symbol: false });
}
/** Miktar (litre, kWh, kg, adet): ondalık dizge. `scale` kadar basamağa izin verir. */
export function parseQuantityInput(text, scale = 3, options = {}) {
    const trimmed = text.replace(/\s/g, "");
    if (trimmed === "")
        return { ok: true, value: null };
    try {
        const decimal = Decimal.parseTr(trimmed);
        if (decimal.isNegative() && !options.allowNegative)
            return { ok: false, message: "Miktar negatif olamaz" };
        if (!decimal.eq(decimal.round(scale)))
            return { ok: false, message: `En fazla ${scale} ondalık basamak girilebilir` };
        return { ok: true, value: decimal.toString() };
    }
    catch {
        return { ok: false, message: "Geçerli bir miktar girin (ör. 1.250,500)" };
    }
}
export function formatQuantityInput(value, scale = 3) {
    if (value === null || value === undefined || value === "")
        return "";
    return Decimal.from(value).formatTr(scale);
}
//# sourceMappingURL=parse.js.map